"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpPdfViewer = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const PDFObject = __importStar(require("pdfobject"));
const core_1 = require("@integro/core");
let ItpPdfViewer = class ItpPdfViewer extends vue_1.default {
    id;
    b64;
    file;
    onB64DataChanged(newValue) {
        this.displayPDF();
    }
    onFileChanged(newValue) {
        this.displayPDF();
    }
    data() {
        return {
            id: (0, core_1.uniqueID)()
        };
    }
    mounted() {
        this.displayPDF();
    }
    displayPDF() {
        if (this.b64) {
            PDFObject.embed(this.b64, `#${this.id}`, this.getEmbedOptions());
        }
        else if (this.file) {
            getBase64(this.file).then(result => {
                if (_.isString(result)) {
                    PDFObject.embed(result, `#${this.id}`, this.getEmbedOptions());
                }
            });
        }
    }
    getEmbedOptions() {
        return {
            forceIframe: true
        };
    }
};
exports.ItpPdfViewer = ItpPdfViewer;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpPdfViewer.prototype, "b64", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", File)
], ItpPdfViewer.prototype, "file", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('b64'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpPdfViewer.prototype, "onB64DataChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('file'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpPdfViewer.prototype, "onFileChanged", null);
exports.ItpPdfViewer = ItpPdfViewer = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div :id="id">&nbsp;</div>' })
], ItpPdfViewer);
function getBase64(file) {
    console.log(file);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
//# sourceMappingURL=pdf-viewer.js.map